import e from "./DomHandler.js";
import "react";
function r(e, r, a) {
  return r in e ? Object.defineProperty(e, r, {
    value: a,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = a, e;
}
var a = function () {
  var r;
  function a() {
    !function (e, r) {
      if (!(e instanceof r)) throw TypeError("Cannot call a class as a function");
    }(this, a);
  }
  return r = [{
    key: "isNavKeyPress",
    value: function value(r) {
      var t = r.keyCode;
      return (t = e.getBrowser().safari && a.SAFARI_KEYS[t] || t) >= 33 && t <= 40 || t === a.KEYS.RETURN || t === a.KEYS.TAB || t === a.KEYS.ESC;
    }
  }, {
    key: "isSpecialKey",
    value: function value(r) {
      var a = r.keyCode;
      return 9 === a || 13 === a || 27 === a || 16 === a || 17 === a || a >= 18 && a <= 20 || e.getBrowser().opera && !r.shiftKey && (8 === a || a >= 33 && a <= 35 || a >= 36 && a <= 39 || a >= 44 && a <= 45);
    }
  }, {
    key: "getKey",
    value: function value(r) {
      var t = r.keyCode || r.charCode;
      return e.getBrowser().safari && a.SAFARI_KEYS[t] || t;
    }
  }, {
    key: "getCharCode",
    value: function value(e) {
      return e.charCode || e.keyCode || e.which;
    }
  }, {
    key: "onKeyPress",
    value: function value(r, t, n) {
      if (!n) {
        var i = a.DEFAULT_MASKS[t] ? a.DEFAULT_MASKS[t] : t,
          o = e.getBrowser();
        if (!r.ctrlKey && !r.altKey) {
          var u = this.getKey(r);
          if (!(o.mozilla && (this.isNavKeyPress(r) || u === a.KEYS.BACKSPACE || u === a.KEYS.DELETE && 0 === r.charCode))) {
            var l = String.fromCharCode(this.getCharCode(r));
            !(o.mozilla && (this.isSpecialKey(r) || !l)) && (i.test(l) || r.preventDefault());
          }
        }
      }
    }
  }, {
    key: "validate",
    value: function value(e, r) {
      var a = e.target.value,
        t = !0;
      return a && !r.test(a) && (t = !1), t;
    }
  }], function (e, r) {
    for (var a = 0; a < r.length; a++) {
      var t = r[a];
      t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
    }
  }(a, r), a;
}();
r(a, "DEFAULT_MASKS", {
  pint: /[\d]/,
  int: /[\d\-]/,
  pnum: /[\d\.]/,
  money: /[\d\.\s,]/,
  num: /[\d\-\.]/,
  hex: /[0-9a-f]/i,
  email: /[a-z0-9_\.\-@]/i,
  alpha: /[a-z_]/i,
  alphanum: /[a-z0-9_]/i
}), r(a, "KEYS", {
  TAB: 9,
  RETURN: 13,
  ESC: 27,
  BACKSPACE: 8,
  DELETE: 46
}), r(a, "SAFARI_KEYS", {
  63234: 37,
  63235: 39,
  63232: 38,
  63233: 40,
  63276: 33,
  63277: 34,
  63272: 46,
  63273: 36,
  63275: 35
});
export { a as default };